export const GET_COURSES_SUCCESS = 'GET_COURSES_SUCCESS';
export const GET_COURSES_ERROR = 'GET_COURSES_ERROR';

export const GET_MODULES_SUCCESS = 'GET_MODULES_SUCCESS';
export const GET_MODULES_ERROR = 'GET_MODULES_ERROR';

export const GET_SPECIFIC_MODULE_SUCCESS = 'GET_SPECIFIC_MODULE_SUCCESS';
export const GET_SPECIFIC_MODULE_ERROR = 'GET_SPECIFIC_MODULE_ERROR';

export const GET_SPECIFIC_COURSE_SUCCESS = 'GET_SPECIFIC_COURSE_SUCCESS';
export const GET_SPECIFIC_COURSE_ERROR = 'GET_SPECIFIC_COURSE_ERROR';

export const ADD_COURSE_SUCCESS = 'ADD_COURSE_SUCCESS';
export const ADD_COURSE_ERROR = 'ADD_COURSE_ERROR';

export const DELETE_COURSE_SUCCESS = 'DELETE_COURSE_SUCCESS';
export const DELETE_COURSE_ERROR = 'DELETE_COURSE_ERROR';

export const DELETE_MODULE_SUCCESS = 'DELETE_MODULE_SUCCESS';
export const DELETE_MODULE_ERROR = 'DELETE_MODULE_ERROR';

export const ADD_MODULE_SUCCESS = 'ADD_MODULE_SUCCESS';
export const ADD_MODULE_ERROR = 'ADD_MODULE_ERROR';

export const VIEW_USER_SUCCESS = 'VIEW_USER_SUCCESS';
export const VIEW_USER_ERROR = 'VIEW_USER_ERROR';

export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_ERROR = 'ADD_USER_ERROR';

export const LOGIN_SUCCESS= 'LOGIN_SUCCESS';
export const LOGIN_ERROR= 'LOGIN_ERROR';

export const RESET_SUCCESS= 'RESET_SUCCESS';
export const RESET_ERROR= 'RESET_ERROR';

export const UPDATE_PROFILE_SUCCESS= 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR= 'UPDATE_PROFILE_ERROR';

export const UPDATE_MODULE_SUCCESS = 'UPDATE_MODULE_SUCCESS';
export const UPDATE_MODULE_ERROR = 'UPDATE_MODULE_ERROR'

export const UPDATE_COURSE_SUCCESS = 'UPDATE_COURSE_SUCCESS';
export const UPDATE_COURSE_ERROR = 'UPDATE_COURSE_ERROR'
